import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcNotification, RpcNotificationKey } from './rpc-notification-model';

export class RpcNotificationClient {
    /**
     * The notification command.
     *
     * @param data the notification object.
     * @return Promise<void> the promise object.
     */
    public static notify(rpc: Rpc, data: RpcNotification): Promise<void> {
        return RpcInboundClient.call(rpc, RpcNotificationKey.command, RpcNotificationKey.version, data);
    }
}
